<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-top">
        <div class="footer-brand">
          <div class="footer-logo">
            <img class="logo-image" src="/logo-novalab.png" :alt="$t('brand.name')" />
            <span class="logo-name">{{ $t('brand.name') }}</span>
          </div>
          <p class="brand-desc">{{ $t('footer.desc') }}</p>
          <div class="social-links">
            <div class="social-icon" v-for="s in socials" :key="s.id" :title="s.name">
              <i :class="s.icon"></i>
            </div>
          </div>
        </div>
        <div class="footer-links" v-for="col in linkCols" :key="col.id">
          <h5>{{ col.title }}</h5>
          <ul>
            <li v-for="link in col.links" :key="link"><a>{{ link }}</a></li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="footer-certs"><span v-for="cert in bottomCerts" :key="cert">{{ cert }}</span></div>
        <div class="footer-copy">{{ $t('footer.copy') }}</div>
      </div>
    </div>
  </footer>
</template>

<script>
const socialIcons = {
  wechat: 'el-icon-chat-dot-round',
  weibo: 'el-icon-share',
  linkedin: 'el-icon-connection',
  video: 'el-icon-video-camera'
}

export default {
  name: 'FooterBar',
  computed: {
    socials() {
      return this.$tm('footer.socials').map(social => ({
        ...social,
        icon: socialIcons[social.id]
      }))
    },
    linkCols() {
      return this.$tm('footer.linkCols')
    },
    bottomCerts() {
      return this.$tm('footer.certs')
    }
  }
}
</script>

<style lang="less" scoped>
.footer { background: #020810; padding-top: 72px; }
.footer-top { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 48px; padding-bottom: 48px; border-bottom: 1px solid rgba(255,255,255,.06); }
.footer-logo { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }
.logo-image { display: block; width: 92px; height: 52px; object-fit: contain; object-position: left center; }
.logo-name { font-size: 22px; font-weight: 900; color: #fff; letter-spacing: 1px; white-space: nowrap; }
.brand-desc { font-size: 13px; color: rgba(255,255,255,.45); line-height: 1.8; margin-bottom: 20px; max-width: 320px; }
.social-links { display: flex; gap: 10px; }
.social-icon { width: 36px; height: 36px; border-radius: 8px; background: rgba(255,255,255,.06); border: 1px solid rgba(255,255,255,.1); display: flex; align-items: center; justify-content: center; color: rgba(255,255,255,.5); font-size: 16px; cursor: pointer; transition: all .2s; }
.social-icon:hover { background: rgba(0,201,167,.15); border-color: rgba(0,201,167,.3); color: #00c9a7; }
.footer-links h5 { font-size: 14px; font-weight: 700; color: rgba(255,255,255,.8); margin-bottom: 18px; letter-spacing: .5px; }
.footer-links ul { list-style: none; display: flex; flex-direction: column; gap: 10px; margin: 0; padding: 0; }
.footer-links a { font-size: 13px; color: rgba(255,255,255,.4); cursor: pointer; transition: color .2s; }
.footer-links a:hover { color: #00c9a7; }
.footer-bottom { padding: 24px 0; display: flex; flex-direction: column; gap: 12px; align-items: center; }
.footer-certs { display: flex; flex-wrap: wrap; gap: 16px; justify-content: center; }
.footer-certs span { font-size: 11px; color: rgba(255,255,255,.25); padding: 4px 10px; border: 1px solid rgba(255,255,255,.06); border-radius: 20px; }
.footer-copy { font-size: 12px; color: rgba(255,255,255,.2); text-align: center; }
@media (max-width: 1000px) { .footer-top { grid-template-columns: 1fr 1fr; } }
@media (max-width: 600px) { .footer-top { grid-template-columns: 1fr; gap: 32px; } }
</style>
